<template>
  <v-container fluid>
    <v-layout class="mt-5">
      <v-flex sm6 offset-sm3 md4 offset-md4 class="mt-2">
        <div class="text-xs-center">
          <img class="logo-img" src="https://res.cloudinary.com/tesseract-ics/image/upload/c_scale,w_200/site/logo" alt="ICS Logo">
        </div>
        <form> 
          <v-text-field
            label="Username"
            v-model="username"
            color="blue"
            :error-messages="usernameErrors"
            @input="$v.username.$touch()"
            @blur="$v.username.$touch()"
            @keyup.enter="logIn"
            required
          ></v-text-field> 
          <v-text-field
            label="Password"
            type="password"
            v-model="password"
            color="blue"
            :error-messages="passwordErrors"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
            @keyup.enter="logIn"
            required
          ></v-text-field>
          <v-btn round block color="success" @click="logIn" @keyup.enter="logIn">Log in</v-btn>
        </form>
      </v-flex>
    </v-layout>
    <!-- <v-dialog v-model="loading" persistent max-width="250" ></v-dialog> -->
  </v-container>
</template>

<script>
import VueNotifications from 'vue-notifications'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
export default {
  mixins: [validationMixin],
  validations: {
    username: {
      required
    },
    password: {
      required
    }
  },
  data(){
    return {
      username: '',
      password: '',
      loading: true,
      snackbar: {
        timeout: 3000,
        text: '',
        appear: false
      }
    }
  },
  methods: {
    logIn(){
      const { username, password } = this
      this.$v.$touch()

      if(!this.$v.$error){
        this.$Progress.start()
        this.$store.dispatch('REQUEST_TOKEN', { username, password })
          .then((role) => {
            if(role === 0){
              this.$router.push('/admin')
            } else if(role === 1){
              this.$router.push('/instructor')
            } else if(role === 2){
              this.$router.push('/student')
            }
            this.$Progress.finish()
          }).catch(err => {
            console.log(err)
            if(err.response.data.code === 401)
              this.showErrorMsg({ title: err.response.statusText, message: err.response.data.message })
            this.$Progress.fail()
          })
      }
    },
    deleteFormFields(){
      this.username = ''
      this.password = ''
    }
  },
  computed: {
    usernameErrors(){
      const errors = []
      if(!this.$v.username.$dirty) return errors
      // !this.$v.username.maxLength && errors.push('Username must be valid')
      !this.$v.username.required && errors.push('Username is required')
      return errors
    },
    passwordErrors(){
      const errors = []
      if(!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required')
      return errors
    }
  },
  notifications: {
    showErrorMsg: { type: VueNotifications.types.error }
  }
}
</script>

<style>
.swal-title,
.swal-text,
.swal-button{
  font-family: 'Roboto',sans-serif;
}

.swal-button{
  background-color: #43a047;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage/Login.vue